import MailchimpSubscribe, { EmailFormFields } from "react-mailchimp-subscribe";
import { useState, useEffect } from 'react';

const CustomForm = ({ status, message, onValidated }: any) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: any) => {
    e.preventDefault();
    email &&
      email.indexOf("@") > -1 &&
      onValidated({
        EMAIL: email,
      });

  }

  useEffect(() => {
    if (status === "success") clearFields();
  }, [status])

  const clearFields = () => {
    setEmail('');
  }

  return (
    <form
      className="mc__form"
      onSubmit={(e) => handleSubmit(e)}
    >
      <h3 className="mc__title text-left">
        {status === "success" ? "Success!" : ""}
      </h3>

      {status === "sending" && (
        <div
          className="mc__alert mc__alert--sending text-left"
        >Sending...</div>
      )}
      {status === "error" && (
        <div
          className="mc__alert mc__alert--error"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      {status === "success" && (
        <div
          className="mc__alert mc__alert--success"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}

      {status !== "success" ? (
        <div className="mc__field-container">

          <InputField
            label="Email"
            onChangeHandler={(e: any) => setEmail(e.target.value)}
            type="email"
            value={email}
            placeholder="your@email.com"
            isRequired
          />
          {/*Close button appears if form was successfully sent*/}
          {status === 'success' ? null : <PrimaryCTAButton /> }
        </div>
      ) : null}
    </form>
  );
};

const PrimaryCTAButton = () => {
  return (
    <input type={"submit"} className='sm:mt-0 mt-6 sm:ml-6 ml-0 w-32 bg-white text-black text-sm my-auto py-3 rounded cursor-pointer' />
  )
}

const InputField = ({ isRequired, label, onChangeHandler, type, value, placeholder }: { isRequired: boolean, label: string, onChangeHandler: any, type: string, value: string, placeholder: string }) => {
  return (
    <input aria-label={label} required={isRequired} type={type} value={value} className='p-2 rounded text-sm w-64 text-black' placeholder={placeholder} onChange={onChangeHandler} />
  )
}

function MailChimp({user, id}: {user: string; id: string}) {
  const postUrl = `https://app.us11.list-manage.com/subscribe/post?u=${user}&id=${id}`;

  return (
    <MailchimpSubscribe
    url={postUrl}
    render={({ subscribe, status, message }) => (
        <CustomForm
        status={status}
        message={message}
        onValidated={(formData: EmailFormFields) => subscribe(formData)}
        />
    )}
    />
  );
}

export default MailChimp;
